import React, { useState } from 'react';
import MuiButton, { ButtonProps } from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export type DeleteWithConfirmButtonProps = ButtonProps & {
    text: string;
    variant?: 'text' | 'outlined' | 'contained';
    size?: 'small' | 'medium' | 'large';
    textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
    onConfirm?: () => Promise<void> | void;
    disabled?: boolean
}

export const DeleteWithConfirmButton = ({ text, size, variant = "outlined", textTransform = "none", onConfirm, disabled, ...props }: DeleteWithConfirmButtonProps): JSX.Element => {

    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

    const handleButtonClick = () => {
        setIsDeleteConfirmOpen(true);
    }

    const handleConfirm = async () => {
        if (onConfirm) {
            await onConfirm();
        }
        setIsDeleteConfirmOpen(false);
    }

    const handleCancel = () => {
        setIsDeleteConfirmOpen(false);
    }

    return (
        <Box display="flex" alignItems="center">
            {!isDeleteConfirmOpen ? (
                <MuiButton
                    size={size}
                    onClick={handleButtonClick}
                    variant={variant}
                    color='error'
                    disabled={disabled}
                    style={{ textTransform: textTransform }}
                    {...props}
                >
                    {text}
                </MuiButton>
            ) : (
                <>
                    <Typography variant="body2" style={{ marginRight: 8 }}>
                        Silmek istediğinize emin misiniz?
                    </Typography>
                    <MuiButton
                        size="small"
                        onClick={handleConfirm}
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", marginRight: 8 }}
                    >
                        EVET
                    </MuiButton>
                    <MuiButton
                        size="small"
                        onClick={handleCancel}
                        variant="outlined"
                        color='error'
                        style={{ textTransform: "none" }}
                    >
                        HAYIR
                    </MuiButton>
                </>
            )}
        </Box>
    )
}
